export const recentGiftsSortByList = [
	{ label: 'Date (descending)', rule: { date: -1 } },
	{ label: 'Date (ascending)', rule: { date: 1 } },
	{ label: 'Amount (descending)', rule: { amount: -1 } },
	{ label: 'Amount (ascending)', rule: { amount: 1 } },
];

export const giftsInitialState = {
	entities: {},
	totalToDisplay: 0,
	skip: 0,
	fetchError: null,
	errorType: null,
	sortBy: recentGiftsSortByList[0],
};



// WEBPACK FOOTER //
// ./src/redux/gifts/gifts.initialState.js